var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiPageTitle',{attrs:{"title":_vm.appLogin,"back-link":{ name: 'applications' }}})}
var staticRenderFns = []

export { render, staticRenderFns }